import { createServiceCategory } from "api/projects";
import Button from "components/Button";
import Form from "components/Form";
import Modal from "components/Modal";
import useAsync from "hooks/use-async";
import React, { FC } from "react";
import { ServiceCategory } from "types/models";
import { displayErrorFromAxiosException } from "utils/errors";
import { required } from "utils/form";

import styles from "./styles.module.scss";

interface Props {
  visible: boolean;
  handleClose(): void;
  onModalClosed(): void;
  parent: ServiceCategory | null;
  onSuccess(): void;
}

interface FormValues {
  name: string;
}

const CreateServiceCategory: FC<Props> = ({
  visible,
  handleClose,
  onModalClosed,
  parent,
  onSuccess,
}) => {
  const [submit, submitting] = useAsync((formValues: FormValues) => {
    return createServiceCategory(parent && parent.id, formValues)
      .then(() => {
        onSuccess();
        handleClose();
      })
      .catch(
        displayErrorFromAxiosException("Failed to create service sub category")
      );
  });

  return (
    <Modal
      onModalClosed={onModalClosed}
      handleClose={handleClose}
      visible={visible}
      title={
        parent
          ? `Creating service sub category for: ${parent.name}`
          : "Creating service category"
      }
    >
      <Form
        className={styles.form}
        onSubmit={submit}
        fields={[
          {
            type: "text",
            title: "Name",
            id: "name",
            validate: [required("Name is required for creation")],
          },
        ]}
      >
        {({ handleSubmit, invalid, hasChanged }) => (
          <Button
            className={styles.submit}
            disabled={!hasChanged || invalid}
            loading={submitting}
            onClick={handleSubmit}
          >
            Create
          </Button>
        )}
      </Form>
    </Modal>
  );
};

export default CreateServiceCategory;
